import { Col, Row } from "react-bootstrap";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import BMXQuillArea from "../../../../../../Components/BMXQuillArea/BMXQuillArea";
import { useTranslation } from "react-i18next";
import { useForm } from "react-final-form";
import { useRef } from "react";

const SettingsServiceFormStepTwo = ({ initialValues = {} }) => {
  const { t } = useTranslation();
  const form = useForm();

  const isFirstChange = useRef(true);

  return (
    <div className="justify-content-start">
      <Row>
        <Col>
          <BMXSeparator title={t("global:settings.serviceChecklist")} />
        </Col>
      </Row>

      <Row>
        <Col>
          <BMXQuillArea
            content={initialValues?.CHECKLIST_TEXT?.value?.value || ""}
            onChangeText={(editor) => {
              if (isFirstChange.current) {
                isFirstChange.current = false;
                return;
              }

              form.change("CHECKLIST_TEXT", {
                value: { value: editor.root.innerHTML },
              });
            }}
            className="EmailArea"
          />
        </Col>
      </Row>
    </div>
  );
};

export default SettingsServiceFormStepTwo;